import {
  FETCH_CATALOG_FIELD_TYPES_REQUEST,
  FETCH_CATALOG_FIELD_TYPES_RESPONSE,
  FETCH_CATALOG_FIELD_TYPES_ERROR,
} from './actionTypes';

export const initialState = {
  isLoading: false,
  undefinedList: [],
  all: {},
};

const catalogFieldTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG_FIELD_TYPES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CATALOG_FIELD_TYPES_RESPONSE:
      return {
        ...state,
        isLoading: false,
        undefinedList: [...action.fieldTypes.undefined],
        all: { ...state.all, [action.tableName]: action.fieldTypes.all },
      };
    case FETCH_CATALOG_FIELD_TYPES_ERROR:
      return {
        ...state,
        isLoading: false,
        undefinedList: [],
      };
    default:
      return state;
  }
};

export default catalogFieldTypesReducer;
